/**
 * Created by Victor Rojo on 21/9/17.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';



import { CloudAccount } from "../model/cloudAccount";

@Injectable()
export class CloudAccountService{

  private basePath = "api/v1/cloud_account/";
  constructor(
    private http: HttpClient
  ) {}

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  get(id: string):Promise<any> {
    let url = this.basePath + id;
    return this.http
      .get(url)
      .toPromise()
      .then( response => response as CloudAccount )
      .catch(error => this.errorHandler(error));
  }
  patch(id: string, data:any):Promise<any> {
    let url = this.basePath + id;
    return this.http
      .patch(url, data, { responseType: 'text' }) //Hack for new HttpClient that automatically runs .json() on response
      .toPromise()
      .catch(error => this.errorHandler(error));
  }

  check(filter: string):Promise<any> {
    let url = this.basePath + "check?field=" +  filter;
    return this.http
      .get(url)
      .toPromise()
      .catch(error => this.errorHandler(error));
  }

}
